import getData from '../data'

export default async function getMediasByCities(city,nbPerBlock,nbBlock){
    let url =process.env.SOURCE_API + "rest/2.0/medias/getByCity.php";
    let data = [
        {name:'limit',value:nbPerBlock},
        {name:'city',value:city},
    ]
    if(nbBlock){
        data.push({name:'offset',value:nbBlock * nbPerBlock})
    }
    let articles =await getData(url,'POST',data);
    return articles;
}